import { PageTitleWithNav } from "../modules/PageHeaders";
import EMinuteEditor from "./modules/EMinuteEditor";
import { useNavigate } from "react-router-dom";
import useEminuteAction from "./useAdminEminuteActions";
import { useState } from "react";

export const NewEminute = () => {
  const navigate = useNavigate();
  const initialFormValues = {
    title: "",
    date: "",
    content: "",
    audience: "BOTH",
    send_sms: false,
  };
  const [content, setContent] = useState(initialFormValues.content);
  const { createEMinute, changeStatus } = useEminuteAction();

  const handleSaveDraft = async (formikValues, formikHelpers) => {
    const reqBody = {
      ...formikValues,
      content,
      audience: formikValues.audience ?? "BOTH",
      send_sms: !!formikValues.send_sms,
    };
    const resetForm = formikHelpers?.resetForm;
    const { data, error } = await createEMinute(reqBody, () => {
      if (resetForm) resetForm();
      setContent("");
    });
    if (error || !data?.status) {
      throw new Error(error?.data?.message || data?.message || "Failed to save draft");
    }
  };

  const handleSaveAndPublish = async (formikValues, formikHelpers) => {
    const reqBody = {
      ...formikValues,
      content,
      audience: formikValues.audience ?? "BOTH",
      send_sms: !!formikValues.send_sms,
    };
    const { data, error } = await createEMinute(reqBody);
    if (error || !data?.status) {
      throw new Error(error?.data?.message || data?.message || "Failed to create E-minute");
    }
    const id = data?.data?.id;
    if (id) {
      await changeStatus(id);
    }
    // Reset form and navigate to list view on success
    formikHelpers?.resetForm?.({ values: initialFormValues });
    setContent("");
    navigate("/super_admin/eminutes");
  };

  return (
    <section className="mx-2 mx-lg-4 min-vh-100">
      <div className="py-1"></div>
      <PageTitleWithNav
        title={"New E-minutes"}
        action={() => {
          navigate(-1);
        }}
      />
      <div>
        <EMinuteEditor
          handleContentChange={setContent}
          initialValues={initialFormValues}
          handleSaveDraft={handleSaveDraft}
          handleSaveAndPublish={handleSaveAndPublish}
        />
      </div>
    </section>
  );
};
